var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6707 13.6327C11.6707 14.5244 10.9658 15.2472 10.0964 15.2472C9.22694 15.2472 8.52209 14.5244 8.52209 13.6327C8.52209 12.741 9.22694 12.0182 10.0964 12.0182C10.9658 12.0182 11.6707 12.741 11.6707 13.6327Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30121 6.81333V5.8C6.30121 3.70132 8.00037 2 10.0964 2C12.1924 2 13.8916 3.70132 13.8916 5.8V6.81333H16.0977C17.3593 6.81333 18.3347 7.8844 18.1758 9.0953L16.8458 19.2286C16.7129 20.2411 15.8226 21 14.7678 21H5.42502C4.37016 21 3.47987 20.2411 3.34699 19.2286L2.017 9.0953C1.85808 7.8844 2.83343 6.81333 4.09504 6.81333H6.30121ZM7.81928 5.8V6.81333H12.3735V5.8C12.3735 4.54079 11.354 3.52 10.0964 3.52C8.83877 3.52 7.81928 4.54079 7.81928 5.8ZM10.0964 10C8.1401 10 6.55422 11.6063 6.55422 13.5879C6.55422 15.7318 8.55004 17.282 9.78945 17.9247C9.98315 18.0251 10.2096 18.0251 10.4033 17.9247C11.6427 17.282 13.6386 15.7318 13.6386 13.5879C13.6386 11.6063 12.0527 10 10.0964 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9398 18C17.9398 17.5858 18.2796 17.25 18.6988 17.25H22.241C22.6602 17.25 23 17.5858 23 18C23 18.4142 22.6602 18.75 22.241 18.75H18.6988C18.2796 18.75 17.9398 18.4142 17.9398 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4458 15C18.4458 14.5858 18.7856 14.25 19.2048 14.25H22.241C22.6602 14.25 23 14.5858 23 15C23 15.4142 22.6602 15.75 22.241 15.75H19.2048C18.7856 15.75 18.4458 15.4142 18.4458 15Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9518 12C18.9518 11.5858 19.2916 11.25 19.7108 11.25H22.241C22.6602 11.25 23 11.5858 23 12C23 12.4142 22.6602 12.75 22.241 12.75H19.7108C19.2916 12.75 18.9518 12.4142 18.9518 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag9);
export default __webpack_public_path__ + "static/media/shopping-bag-9.7bf5a3c2d27ce3d18dcafda88a720c21.svg";
export { ForwardRef as ReactComponent };